module.exports = __webpack_public_path__ + "static/media/DSC09691.a455ecc7.jpg";